<script lang="ts" setup>
const { t } = useI18n()
const share = useShare()
const showDrawer = ref(false)

const handleShowDrawer = (state: boolean) => {
  if (share.nativeShareIsAvailable.value) return share.handleOption()
  showDrawer.value = state
}
</script>

<template>
  <button
    class="floating-share fixed bottom-4 left-4 z-20 h-14 w-14 rounded-full font-semibold leading-[0] text-white shadow-top-md transition-colors sm:hidden"
    @click.stop="handleShowDrawer(true)"
  >
    <RIcon size="24" :name="isIOs() ? 'ic:round-ios-share' : 'mdi:share-variant-outline'" />
  </button>
  <RBaseDrawer
    v-if="!share.nativeShareIsAvailable.value"
    v-model:show="showDrawer"
    placement="bottom"
    :show-close="false"
    with-backdrop
    height-class="h-auto"
    padding-class="p-6"
    background-class="bg-white"
  >
    <div class="flex flex-col gap-4">
      <p class="self-center">{{ t('components.floating.share.title') }}</p>

      <span class="block w-full border border-gray-200" />

      <RSocialList :list="share.options.slice(0, 1)" />

      <RSocialList :list="share.options.slice(1)" />

      <button
        class="flex-shrink-0 rounded-full border-1.5 border-black bg-white px-6 py-2 text-base"
        @click="handleShowDrawer(false)"
      >
        {{ t('components.floating.share.actions.cancel') }}
      </button>
    </div>
  </RBaseDrawer>
</template>

<style scoped>
.floating-share {
  background: var(--color-primary);
}
</style>
